module.exports = __webpack_public_path__ + "static/media/bell.b2453b11.svg";